import type { SerializedStyles } from "@emotion/react";
import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";
import type { BadgeProps } from ".";

const primaryCSS = css({
  background: vars.semantic.color.layerSelected,
  color: vars.semantic.color.textPrimary,

  "&[data-clay-badge-state='hover']": {
    background: vars.semantic.color.layerSelectedHover,
  },

  "&[data-clay-badge-on='true']": {
    color: vars.semantic.color.textOn,
    background: vars.color.imBlue[600],
  },

  "&[data-clay-badge-state='disabled']": {
    color: vars.semantic.color.textDisabled,
    background: vars.semantic.color.surfaceSub,
  },
});

const secondaryCSS = css({
  background: vars.semantic.color.surfaceSub,
  color: vars.semantic.color.textSub,

  "&[data-clay-badge-state='hover']": {
    background: vars.semantic.color.actionPrimaryDisabled,
  },

  "&[data-clay-badge-on='true']": {
    color: vars.semantic.color.textOn,
    background: vars.color.imBlue[600],
  },

  "&[data-clay-badge-state='disabled']": {
    color: vars.semantic.color.textDisabled,
    background: vars.semantic.color.surfaceSub,
  },
});

const criticalCSS = css({
  background: vars.semantic.color.surfaceCritical,
  color: vars.semantic.color.textCritical,

  "&[data-clay-badge-state='hover']": {
    // 똑같음
  },

  "&[data-clay-badge-on='true']": {
    color: vars.semantic.color.textOn,
    background: "#D34",
  },

  "&[data-clay-badge-state='disabled']": {
    color: vars.semantic.color.textDisabled,
    background: vars.semantic.color.surfaceSub,
  },
});

const sizeDefaultCSS = css({
  padding: `${vars.spacing["05"]} ${vars.spacing["15"]}`,
  minWidth: "20px",
  ...vars.semantic.typography["label-small"],
});

const sizeLargeCSS = css({
  padding: `0 ${vars.spacing["15"]}`,
  minWidth: "24px",
  ...vars.semantic.typography["label-medium"],
});

const sizeSmallCSS = css({
  padding: `${vars.spacing["1"]} ${vars.spacing["15"]}`,
  minWidth: "20px",
  ...vars.semantic.typography["label-xsmall"],
});

export const sizeVariant = {
  default: sizeDefaultCSS,
  large: sizeLargeCSS,
  small: sizeSmallCSS,
};

export const typeVariant: Record<BadgeProps["type"], SerializedStyles> = {
  primary: primaryCSS,
  critical: criticalCSS,
  secondary: secondaryCSS,
};

const dotPrimaryCSS = css({
  background: vars.semantic.color.iconAccent,
});

const dotSecondaryCSS = css({
  background: vars.semantic.color.icon,
});

const dotCriticalCSS = css({
  background: vars.semantic.color.iconCritical,
});

export const dotTypeVariant = {
  primary: dotPrimaryCSS,
  critical: dotCriticalCSS,
  secondary: dotSecondaryCSS,
};

const dotSmallSizeCSS = css({
  width: "6px",
  height: "6px",
  outlineWidth: "2px",
});

const dotMediumSizeCSS = css({
  width: "8px",
  height: "8px",
  outlineWidth: "2px",
});

const dotLargeSizeCSS = css({
  width: "10px",
  height: "10px",
  outlineWidth: "2px",
});

const dotLargeBoldSizeCSS = css({
  width: "10px",
  height: "10px",
  outlineWidth: "3px",
});

export const dotSizeVariant = {
  small: dotSmallSizeCSS,
  medium: dotMediumSizeCSS,
  large: dotLargeSizeCSS,
  largeBold: dotLargeBoldSizeCSS,
};
